/* Shopify Liquid product carousels: no autoplay, native touch scrolling. */
(() => {
  'use strict';
  if (window.autoTuningProductCarousels) return;
  window.autoTuningProductCarousels = true;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(scope = document) {
    scope.querySelectorAll('[data-product-carousel]').forEach(carousel => {
      if (carousel.dataset.carouselReady) return;
      carousel.dataset.carouselReady = 'true';
      const track = carousel.querySelector('[data-carousel-track]');
      const cards = [...track.children];
      const controls = carousel.querySelector('[data-carousel-controls]');
      const dots = carousel.querySelector('[data-carousel-dots]');
      const previous = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');
      const status = carousel.querySelector('[data-carousel-status]');
      let positions = [], visible = 4, page = 0, pointer = null, suppressClick = false, frame;
      function currentPage() {
        return positions.reduce((best, value, index) => Math.abs(track.scrollLeft - value) < Math.abs(track.scrollLeft - positions[best]) ? index : best, 0);
      }
      function update() {
        if (!positions.length) return;
        page = currentPage();
        [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === page)));
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      }
      function go(index) {
        index = Math.max(0, Math.min(index, positions.length - 1));
        track.scrollTo({left: positions[index] || 0, behavior: reducedMotion.matches ? 'instant' : 'smooth'});
        status.textContent = `Pagina ${index + 1} din ${positions.length} a caruselului`;
      }
      function measure() {
        if (!track.clientWidth) return;
        visible = Number(getComputedStyle(carousel).getPropertyValue('--carousel-visible')) || 4;
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const step = (cards[0]?.getBoundingClientRect().width || 0) + (parseFloat(getComputedStyle(track).columnGap) || 0);
        const count = Math.ceil(cards.length / visible);
        positions = Array.from({length: Math.max(1, count)}, (_, i) => Math.min(maximum, i * visible * step));
        controls.hidden = maximum <= 2;
        if (dots.children.length !== positions.length) {
          dots.replaceChildren();
          positions.forEach((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'product-carousel-dot';
            dot.setAttribute('aria-controls', track.id);
            dot.setAttribute('aria-label', `Arată pagina ${i + 1} din ${positions.length} a caruselului`);
            dot.append(document.createElement('span'));
            dot.firstChild.setAttribute('aria-hidden', 'true');
            dot.addEventListener('click', () => go(i));
            dots.append(dot);
          });
        }
        update();
      }
      previous.addEventListener('click', () => go(currentPage() - 1));
      next.addEventListener('click', () => go(currentPage() + 1));
      track.addEventListener('scroll', () => {cancelAnimationFrame(frame); frame = requestAnimationFrame(update);}, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        let target;
        if (event.key === 'ArrowLeft') target = currentPage() - 1;
        if (event.key === 'ArrowRight') target = currentPage() + 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = positions.length - 1;
        if (target !== undefined) {event.preventDefault(); go(target);}
      });
      dots.addEventListener('keydown', event => {
        const index = [...dots.children].indexOf(event.target);
        if (index < 0) return;
        let target;
        if (event.key === 'ArrowLeft') target = Math.max(0, index - 1);
        if (event.key === 'ArrowRight') target = Math.min(positions.length - 1, index + 1);
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = positions.length - 1;
        if (target !== undefined) {event.preventDefault(); dots.children[target].focus(); go(target);}
      });
      track.addEventListener('dragstart', event => event.preventDefault());
      track.addEventListener('pointerdown', event => {
        suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button,input,select,textarea')) return;
        pointer = {id: event.pointerId, x: event.clientX, start: track.scrollLeft, dragged: false};
      });
      track.addEventListener('pointermove', event => {
        if (!pointer || pointer.id !== event.pointerId) return;
        const distance = event.clientX - pointer.x;
        if (!pointer.dragged && Math.abs(distance) < 6) return;
        if (!pointer.dragged) {
          pointer.dragged = true;
          track.setPointerCapture(event.pointerId);
          track.classList.add('is-dragging');
          track.style.scrollSnapType = 'none';
          track.style.scrollBehavior = 'auto';
        }
        event.preventDefault();
        track.scrollLeft = pointer.start - distance;
      });
      function finishDrag(event) {
        if (!pointer || pointer.id !== event.pointerId) return;
        suppressClick = pointer.dragged;
        pointer = null;
        track.classList.remove('is-dragging');
        track.style.removeProperty('scroll-snap-type');
        track.style.removeProperty('scroll-behavior');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      }
      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('lostpointercapture', finishDrag);
      track.addEventListener('click', event => {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(track);
      const panel = carousel.closest('[role="tabpanel"]');
      if (panel) new MutationObserver(() => {if (!panel.hidden) requestAnimationFrame(measure);}).observe(panel, {attributes: true, attributeFilter: ['hidden']});
      measure();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
